import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ReactFlagsSelect from 'react-flags-select';
import showOptionLabel from 'react-flags-select';
import { InputText } from 'primereact/inputtext';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import ReactPhoneInput from "react-phone-input-2";
import defaultCountry from "react-phone-input-2"
import { Link } from 'react-router-dom';
import ContentBlock from '../../Components/contentBlock/ContentBlock';
import { SimpleAncer } from '../../Components/button';
import i18n from '../../i18n';
import LogoBg from '../../assets/images/png/LogoMain.png';
import circle1 from '../../assets/images/svg/circle1.svg';
import circle2 from '../../assets/images/svg/revisedCircle.svg';
import circle3 from '../../assets/images/svg/circle3.svg';
import './Registeration.css';

const Registeration = () => {
  const [select, setSelect] = useState('SE');
  const onSelect = (code) => setSelect(code);
  const [value2, setValue2] = useState('');

  return (
    <div className="registeration h-100-vh text-md-left text-center">
      <Container>
        <img className="LogoImage pt-4" src={LogoBg} />
        <div className='row align-items-center'>
          <Col md={6}>
            <div className="heading-first">
              <h1 className="reg-head">
                Join Pakistan’s largest <br /> healthcare platform today
              </h1>
            </div>
            <hr className="bottom-border"></hr>
            <div className="description">
              <p className="fs-20">
                Our Artificial Intelligence technology helps you connect
              </p>
            </div>
            <div className="main-list text-left">
              <div className="group1">
                <img className="circle" src={circle1} />
                <p>Community of 50,000+ doctors and growing</p>
              </div>
              <div className="group2">
                <img className="circle" src={circle2} />
                <p>Zero Commissions on all appointment bookings*</p>
              </div>
              <div className="group3">
                <img className="circle" src={circle3} />
                <p>
                  Access to enterprise-level medical software to help your
                  practice grow
                </p>
              </div>
            </div>
          </Col>
          <Col md={6}>
            <div className="content ">
              <Row>
                <Col md={12} className="column">
                  {/* <div className="content_container">
                    <ContentBlock
                      heading={i18n.t('lets_get_started')}
                      body={i18n.t('need_create_account_first')}
                    />
                    <form className="form">
                      <h6 className="inputLabel">
                        {i18n.t('phone_number')}*
                      </h6>
                      <div className="select_container">
                        <div className="input_box">
                          <span>+92 </span>
                          <input
                            placeholder=""
                            className="custom_input"
                            type="text"
                          />
                        </div>
                      </div>
                      <h6 className="inputLabel">{i18n.t('full_name')}*</h6>
                      <div className="input_box">
                        <input
                          placeholder=""
                          className="custom_input"
                          type="text"
                        />
                      </div>
                      <h6 className="inputLabel">
                        {i18n.t('email_address')}
                      </h6>
                      <div className="input_box">
                        <input
                          placeholder=""
                          className="custom_input"
                          type="email"
                        />
                      </div>
                      <p className="fs-14 term_condition_text">
                        {i18n.t('clicking_continue_accepting')}
                        <Link to="/">{i18n.t('terms_conditions')}.</Link>
                      </p>
                      <div className="btns_container">
                        <SimpleAncer
                          to="/otpWhenLoggingIn"
                          text={i18n.t('continue')}
                        />
                      </div>
                    </form>
                  </div> */}

                  <div className="registeration-form">
                    <div className="form-control p-4">
                      <h1>Enter Your Details</h1>
                      <div className="d-md-flex">
                      <ReactPhoneInput
                        //  defaultCountry="PK"
                        value="+92"
                          containerStyle={{ marginTop: "15px" }}
                          searchClass="search-class"
                             searchStyle={{ margin: "0", width: "97%", height: "30px" }}
                           enableSearchField
                                disableSearchIcon

                                          />
                        {/* <ReactFlagsSelect
                          selected={select}
                          onSelect={onSelect}
                          // countries={['fi', 'GB', 'IE', 'IT', 'NL', 'SE', 'PK']}
                          // customLabels={{ US: "", GB: "", FR: "", DE: "", IT: "" }}
                          //
                          showSelectedLabel={false}
                          selectedSize={16}
                          showOptionLabel={true}
                          optionsSize={16}
                          // placeholder={false}
                          // searchable={searchable}
                          // searchPlaceholder={searchPlaceholder}
                          // alignOptionsToRight={alignOptionsToRight}
                          fullWidth={true}
                          // disabled={disabled}
                        />
                        {/* <input
                          placeholder="Mobile Number*"
                          className="custom_Number_input"
                          type="text"
                        /> */}{' '}

                        {/* <Box
                          component="form"
                          sx={{
                            '& > :not(style)': {
                              marginLeft: '5px',
                              width: '100%'
                            }
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            id="outlined-basic"
                            label="Mobile Number*"
                            variant="outlined"
                          />
                        </Box> */}
                      </div>
                      <div className="input_box">
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: '5px', width: '100%' }
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            id="outlined-basic"
                            label="Enter Full Name*"
                            // variant="outlined"
                          />
                        </Box>
                      </div>
                      <div className="input_box">
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: '5px', width: '100%' }
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            id="outlined-basic"
                            label="Enter Your PMC Number"
                            variant="outlined"
                          />
                        </Box>
                      </div>
                      <div className="input_box">
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: '5px', width: '100%' }
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            id="outlined-basic"
                            label="List Your Area of Medical Specialty"
                            variant="outlined"
                          />
                        </Box>
                      </div>
                      <div className="input_box">
                        {/* <input
                          placeholder="Enter Your City*
                          "
                          className="custom_input"
                          type="text"
                        /> */}

                        {/* <span className="p-float-label">
                    <InputText id="username" value={value2} onChange={(e) => setValue2(e.target.value)} />
                    <label htmlFor="username">Username</label>
                    </span> */}
                        <Box
                          component="form"
                          sx={{
                            '& > :not(style)': { m: '5px', width: '100%' }
                          }}
                          noValidate
                          autoComplete="off"
                        >
                          <TextField
                            id="outlined-basic"
                            label="Enter Your City"
                            variant="outlined"
                          />
                        </Box>
                      </div>
                    </div>
                  </div>
                  <div className="confirm-button">
                    <button className="btn-group text-uppercase" type="submit">
                      Confirm
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </div>
      </Container>
    </div>
  );
};

export default Registeration;

